<script setup lang="ts">
import SaveButton from "@/components/SaveButton.vue";
import ContactFormFields from "@/contacts/ContactFormFields.vue";
import type { Contact, ContactQuery } from "@/contacts/types";
import type { MutationStatus } from "@tanstack/vue-query";
import { omit } from "lodash-es";
import { ref, toRaw, type Ref } from "vue";

const props = defineProps<{
  contactDetails: ContactQuery;
  updateContactStatus: MutationStatus;
}>();

defineEmits<{
  update: [contact: Contact];
}>();

const contact: Ref<Contact> = ref(
  structuredClone(
    omit(toRaw(props.contactDetails), [
      "address",
      "pendingEmailAddress",
      "pendingPhoneNumber",
    ]),
  ),
);
</script>

<template>
  <form class="box column" @submit.prevent="$emit('update', contact)">
    <ContactFormFields
      v-model="contact"
      :address="props.contactDetails.address"
      :pending-email-address="props.contactDetails.pendingEmailAddress"
      :pending-phone-number="props.contactDetails.pendingPhoneNumber"
    />
    <div class="row row-end">
      <SaveButton :saving-status="updateContactStatus">Speichern</SaveButton>
    </div>
  </form>
</template>
